<template>
  <v-container fluid class="tasks-page pa-0">
    <OperationalTasks />
  </v-container>
</template>

<script>
import OperationalTasks from '@/components/OperationalTasks.vue';

export default {
  name: 'TasksPage',
  components: { OperationalTasks },
};
</script>

<style scoped>
.tasks-page{background:#f7f9fb;min-height:100%}
</style>
